export default "__VITE_ASSET__Bv05LjGb__"